<template>
  <div>

    <Loader v-if="isProcessing" cover/>

    <div class="algolia-header mb-4">
      <div class="flex md:items-start items-center justify-between flex-wrap">

        <!-- ACADEMIC PERIOD -->
        <div class="flex justify-between items-end flex-grow">
          <!--<v-select
            v-model="selectedAcademicPeriod"
            @input="onAcademicPeriodChange"
            class="mr-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-32">
            <vs-select-item v-for="item in academicPeriods" :key="item.id" :value="item" :text="item.periodCode" />
          </v-select>-->
          <v-select v-model="selectedAcademicPeriod"
                    :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :options="academicPeriods"
                    :searchable="false"
                    class="bg-white w-32"
                    label="periodCode"
                    selectOnTab
                    @input="onAcademicPeriodChange">
          </v-select>

          <div class="flex flex-wrap">

            <!-- WHAT TO VIEW -->
            <!--<vs-select
              v-model="selectedViewItem"
              @input="onViewItemChange"
              class="mr-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-48">
              <vs-select-item v-for="item in viewItems" :key="item" :value="item" :text="item" />
            </vs-select>-->

            <v-select v-model="selectedViewItem"
                      :clearable="false"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      :options="viewItems"
                      :searchable="false"
                      class="mr-4 bg-white w-48"
                      selectOnTab
                      @input="onViewItemChange">
            </v-select>

            <!-- ITEM VIEW - GRID/LIST -->
            <div>
              <feather-icon
                :svgClasses="{'text-primary stroke-current': currentItemView === 'item-grid-view'}"
                class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                icon="GridIcon"
                @click="currentItemView='item-grid-view'"/>
              <feather-icon
                :svgClasses="{'text-primary stroke-current': currentItemView === 'item-list-view'}"
                class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                icon="ListIcon"
                @click="currentItemView='item-list-view'"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="algolia-content-container" class="relative clearfix">

      <!-- RIGHT COL -->
      <div>

        <!-- GRID VIEW -->
        <template v-if="currentItemView === 'item-grid-view'">

          <!--CLASS ROOM-->
          <div v-if="selectedViewItem === $t('class-room.class-room') && !isProcessing"
               class="items-grid-view vx-row match-height">

            <!-- UNIVERSITY NEWS -->
            <template v-if="infoTopics && infoTopics.length > 0">
              <div v-for="infoTopic in infoTopics" :key="infoTopic.id"
                   class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
                <info-topic-card :info-topic="infoTopic"></info-topic-card>
              </div>
            </template>



            <template v-if="classRooms && classRooms.length > 0">
              <div v-for="(item, index) in classRooms" :key="item.id"
                   class="vx-col lg:w-1/3 sm:w-1/2 w-full">
                <item-class-room-grid-view :index="index" :item="item">
                </item-class-room-grid-view>
              </div>
            </template>

            <template v-else>
              <div class="vx-col w-full">
                <vx-card class="text-center">
                  <h5 class="font-weight-normal">{{ $t('home.class-not-found') }}</h5>
                </vx-card>
              </div>
            </template>
          </div>

          <!--LIVE CLASS SCHEDULE-->
          <div v-else-if="selectedViewItem === $t('live-class-schedule.live-class-schedule') && !isProcessing"
               class="items-grid-view vx-row match-height">

            <template v-if="liveClassSchedules && liveClassSchedules.length > 0">
              <div v-for="(item, index) in liveClassSchedules" :key="item.id"
                   class="vx-col lg:w-1/3 sm:w-1/2 w-full">
                <item-live-class-schedule-grid-view :index="index" :item="item">
                </item-live-class-schedule-grid-view>
              </div>
            </template>

            <template v-else>
              <div class="vx-col w-full">
                <vx-card class="text-center">
                  <h5 class="font-weight-normal">{{ $t('home.live-schedule-not-found') }}</h5>
                </vx-card>
              </div>
            </template>
          </div>

          <!--ADVISOR ONLINE SCHEDULE-->
          <div v-else-if="selectedViewItem === $t('advisor-online-schedule.title') && !isProcessing"
               class="items-grid-view vx-row match-height">

            <template v-if="advisorOnlineSchedules && advisorOnlineSchedules.length > 0">
              <div v-for="(item, index) in advisorOnlineSchedules" :key="item.id"
                   class="vx-col lg:w-1/3 sm:w-1/2 w-full">
                <item-advisor-online-schedule-grid-view :index="index" :item="item">
                </item-advisor-online-schedule-grid-view>
              </div>
            </template>

            <template v-else>
              <div class="vx-col w-full">
                <vx-card class="text-center">
                  <h5 class="font-weight-normal">{{ $t('home.advisor-online-not-found') }}</h5>
                </vx-card>
              </div>
            </template>

          </div>

        </template>

        <!-- LIST VIEW -->
        <template v-else>

          <!--CLASS ROOM-->
          <item-class-room-list-view v-if="selectedViewItem === $t('class-room.class-room')"
                                     :items="classRooms">

          </item-class-room-list-view>

          <!--LIVE CLASS SCHEDULE-->
          <item-live-class-schedule-list-view
            v-else-if="selectedViewItem === $t('live-class-schedule.live-class-schedule')"
            :items="liveClassSchedules">

          </item-live-class-schedule-list-view>

          <!--ADVISOR ONLINE SCHEDULE-->
          <item-advisor-online-schedule-list-view v-else-if="selectedViewItem === $t('advisor-online-schedule.title')"
                                                  :items="advisorOnlineSchedules">

          </item-advisor-online-schedule-list-view>

        </template>

      </div>
    </div>


    <!--    <vx-card class="grid-view-item mb-base overflow-hidden mb-5" no-body>

          <div slot="no-body">
            <Communication />
          </div>
        </vx-card>-->

  </div>
</template>

<script>
import store from '@/store';
import ItemClassRoomGridView from './Components/ItemClassRoomGridView'
import ItemClassRoomListView from './Components/ItemClassRoomListView'
import ItemLiveClassScheduleGridView from './Components/ItemLiveClassScheduleGridView'
import ItemLiveClassScheduleListView from './Components/ItemLiveClassScheduleListView'
import ItemAdvisorOnlineScheduleGridView from './Components/ItemAdvisorOnlineScheduleGridView'
import ItemAdvisorOnlineScheduleListView from './Components/ItemAdvisorOnlineScheduleListView'
import InfoTopicCard from "@/views/Home/Components/InfoTopic/InfoTopicCard";
import vSelect from 'vue-select'

import AcademicPeriod from '@/store/modules/common-data/academic-period';
import AcademicPeriodConfig from '@/store/modules/common-data/academicPeriodConfig';
import ClassRoom from '@/store/modules/class-room/class-room/index';
import LiveClassSchedule from '@/store/modules/live-class/live-class-schedule/index';
import AdvisorOnlineSchedule from '@/store/modules/advisor-online-schedule/index';
import InfoTopic from '@/store/modules/university-news/info-topic/index';

import {createHelpers} from 'vuex-map-fields';
import {createNamespacedHelpers} from "vuex";
import {i18n} from "@/setup/i18n-setup";

if (!store.state.AcademicPeriod) store.state.registerModule(`AcademicPeriod`, AcademicPeriod);
if (!store.state.AcademicPeriodConfig) store.state.registerModule(`AcademicPeriodConfig`, AcademicPeriodConfig);
if (!store.state.ClassRoom) store.state.registerModule(`ClassRoom`, ClassRoom);
if (!store.state.LiveClassSchedule) store.state.registerModule(`LiveClassSchedule`, LiveClassSchedule);
if (!store.state.AdvisorOnlineSchedule) store.state.registerModule(`AdvisorOnlineSchedule`, AdvisorOnlineSchedule);
if (!store.state.InfoTopic) store.state.registerModule(`InfoTopic`, InfoTopic);

const {
  mapActions: mapAcademicPeriodActions,
} = createNamespacedHelpers(`AcademicPeriod`);
const {
  mapActions: mapAcademicPeriodConfigActions,
} = createNamespacedHelpers(`AcademicPeriodConfig`);
const {
  mapActions: mapClassRoomActions,
} = createNamespacedHelpers(`ClassRoom`);
const {
  mapActions: mapLiveClassScheduleActions,
} = createNamespacedHelpers(`LiveClassSchedule`);
const {
  mapActions: mapAdvisorOnlineScheduleActions,
} = createNamespacedHelpers(`AdvisorOnlineSchedule`);
const {
  mapActions: mapInfoTopicActions,
} = createNamespacedHelpers(`InfoTopic`);


const {
  mapFields: mapAcademicPeriodFields,
} = createHelpers({
  getterType: `AcademicPeriod/getField`,
  mutationType: `AcademicPeriod/updateField`,
});
const {
  mapFields: mapAcademicPeriodConfigFields,
} = createHelpers({
  getterType: `AcademicPeriodConfig/getField`,
  mutationType: `AcademicPeriodConfig/updateField`,
});
const {
  mapFields: mapClassRoomFields,
} = createHelpers({
  getterType: `ClassRoom/getField`,
  mutationType: `ClassRoom/updateField`,
});
const {
  mapFields: mapLiveClassScheduleFields,
} = createHelpers({
  getterType: `LiveClassSchedule/getField`,
  mutationType: `LiveClassSchedule/updateField`,
});
const {
  mapFields: mapAdvisorOnlineScheduleFields,
} = createHelpers({
  getterType: `AdvisorOnlineSchedule/getField`,
  mutationType: `AdvisorOnlineSchedule/updateField`,
});

export default {
  components: {
    ItemClassRoomGridView,
    ItemClassRoomListView,
    ItemLiveClassScheduleGridView,
    ItemLiveClassScheduleListView,
    ItemAdvisorOnlineScheduleGridView,
    ItemAdvisorOnlineScheduleListView,
    InfoTopicCard,
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
    vSelect,
    // Communication: () => import("@/developing/components/communication")
  },
  data() {
    return {
      // Filter Sidebar
      isFilterSidebarActive: true,
      clickNotClose: true,
      currentItemView: 'item-grid-view',

      viewItems: [
        this.$t('class-room.class-room'),
        this.$t('live-class-schedule.live-class-schedule'),
        this.$t('advisor-online-schedule.title'),
      ],

      isProcessing: true,
      //manual data
      selectedAcademicPeriod: null,
      selectedViewItem: i18n.t('class-room.class-room'),
      currentAcademicPeriod: null,
      academicPeriods: [],
      classRooms: [],
      liveClassSchedules: [],
      advisorOnlineSchedules: [],
      infoTopics: [],
    }
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth
    },
    ...mapAcademicPeriodFields({academicPeriodProcessing: 'processing'}),
    ...mapAcademicPeriodConfigFields({academicPeriodConfigProcessing: 'processing'}),
    ...mapClassRoomFields({classRoomProcessing: 'processing',}),
    ...mapLiveClassScheduleFields({liveClassScheduleProcessing: 'processing',}),
    ...mapAdvisorOnlineScheduleFields({advisorOnlineScheduleProcessing: 'processing',}),
  },
  watch: {
    windowWidth() {
      this.setSidebarWidth()
    },
    academicPeriodProcessing(data) {
      this.isProcessing = data;
    },
    academicPeriodConfigProcessing(data) {
      this.isProcessing = data;
    },
    classRoomProcessing(data) {
      this.isProcessing = data;
    },
    liveClassScheduleProcessing(data) {
      this.isProcessing = data;
    },
    advisorOnlineScheduleProcessing(data) {
      this.isProcessing = data;
    },
  },
  methods: {
    //---------------------------------------- State Function ------------------------------------------------------//
    ...mapAcademicPeriodActions({
      getAcademicPeriods: 'getAcademicPeriods',
    }),
    ...mapAcademicPeriodConfigActions({
      getCurrentAcademicPeriodConfig: 'getCurrentAcademicPeriodConfig',
    }),
    ...mapClassRoomActions({
      getClassRoomsByFilter: 'getClassRoomsByFilter',
    }),
    ...mapLiveClassScheduleActions({
      getLiveClassSchedulesByFilter: 'getLiveClassSchedulesByFilter',
    }),
    ...mapAdvisorOnlineScheduleActions({
      getAdvisorOnlineSchedulesByFilter: 'getAdvisorOnlineSchedulesByFilter',
    }),
    ...mapInfoTopicActions({
      getInfoTopicsTeacherFirstPage: 'getInfoTopicsTeacherFirstPage',
    }),
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true
      }
    },

    //---------------------------------------- Event Function ------------------------------------------------------//
    async onAcademicPeriodChange() {
      if (this.selectedViewItem === this.$t('class-room.class-room')) {
        await this.loadClassRoomData();
      } else if (this.selectedViewItem === this.$t('live-class-schedule.live-class-schedule')) {
        await this.loadLiveClassScheduleData();
      } else if (this.selectedViewItem === this.$t('advisor-online-schedule.title')) {
        await this.loadAdvisorOnlineScheduleData();
      }
    },
    async onViewItemChange() {
      if (this.selectedViewItem === this.$t('class-room.class-room')) {
        await this.loadClassRoomData();
      } else if (this.selectedViewItem === this.$t('live-class-schedule.live-class-schedule')) {
        await this.loadLiveClassScheduleData();
      } else if (this.selectedViewItem === this.$t('advisor-online-schedule.title')) {
        await this.loadAdvisorOnlineScheduleData();
      }
    },
    //---------------------------------------- Local Function ------------------------------------------------------//
    async initData() {
      this.academicPeriods = await this.getAcademicPeriods();
      this.currentAcademicPeriod = await this.getCurrentAcademicPeriodConfig();
      this.selectedAcademicPeriod = this.academicPeriods.find(item => {
        return item.periodCode === this.currentAcademicPeriod.learnPeriodCode
      });
    },
    async loadClassRoomData() {
      let payload = {
        classRoomFilterInput: {
          academicPeriodId: this.selectedAcademicPeriod ? this.selectedAcademicPeriod.id : '',
          currentTeacher: true,
        }
      };
      this.classRooms = (await this.getClassRoomsByFilter(payload)).filter(classroom => classroom.subject.isDisabled === false);
    },
    async loadLiveClassScheduleData() {
      let payload = {
        liveClassScheduleFilterInput: {
          academicPeriodId: this.selectedAcademicPeriod ? this.selectedAcademicPeriod.id : '',
          currentTeacher: true,
          isEnabled: true,
        }
      };

      this.liveClassSchedules = await this.getLiveClassSchedulesByFilter(payload);
    },
    async loadAdvisorOnlineScheduleData() {
      let payload = {
        advisorOnlineScheduleFilterInput: {
          academicPeriodId: this.selectedAcademicPeriod ? this.selectedAcademicPeriod.id : '',
          currentTeacher: true,
          isEnabled: true,
        }
      };

      this.advisorOnlineSchedules = await this.getAdvisorOnlineSchedulesByFilter(payload);
    },
  },
  created() {
    this.setSidebarWidth()
  },
  async mounted() {
    this.infoTopics = await this.getInfoTopicsTeacherFirstPage();
    await this.initData();
    await this.loadClassRoomData();
  },
}

</script>


<style lang="scss">
#algolia-instant-search-demo {
  .algolia-header {
    .algolia-filters-label {
      width: calc(260px + 2.4rem);
    }
  }

  #algolia-content-container {

    .vs-sidebar {
      position: relative;
      float: left;
    }
  }

  .algolia-search-input-right-aligned-icon {
    padding: 1rem 1.5rem;
  }

  .algolia-price-slider {
    min-width: unset;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}

.theme-dark {
  #algolia-instant-search-demo {
    #algolia-content-container {
      .vs-sidebar {
        background-color: #10163a;
      }
    }
  }
}

@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: .5rem;
    }

    .vs-sidebar--items {
      border-radius: .5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}

</style>

